import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-help',
  templateUrl: './text-help.component.html',
  styleUrls: ['./text-help.component.scss'],
})
export class TextHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
